import { useQuery } from '@tanstack/react-query';

import { Search } from '@air/api';
import { type Board, type WorkspaceInfo } from '@air/api/types';

import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';
import { type FilterLookupsOptions } from '~/swr-hooks/filters/types';

const PRIVATE_FILTER_OPTIONS = 'PRIVATE_FILTER_OPTIONS';

export const getPrivateFiltersOptionsKey = ({
  workspaceId,
  boardId,
}: {
  workspaceId?: WorkspaceInfo['id'];
  boardId?: Board['id'];
}) => [PRIVATE_FILTER_OPTIONS, { workspaceId, boardId }];

export const useGetPrivateFilterOptions = (boardId?: Board['id']) => {
  const { currentWorkspace } = useCurrentWorkspace();

  return useQuery<FilterLookupsOptions>({
    queryKey: getPrivateFiltersOptionsKey({ workspaceId: currentWorkspace?.id, boardId }),

    queryFn: async () => {
      const workspaceId = currentWorkspace?.id;
      if (!workspaceId) {
        throw new Error('No workspace id');
      }
      const data = await Search.getFilterLookups({ workspaceId, boardId });
      return {
        colors: data.colors,
        uploaders: data.uploaders,
      };
    },
    staleTime: 1000 * 60 * 60 * 1,
    enabled: !!currentWorkspace?.id,
  });
};
